import React from 'react';

import { IFeedCardDetails } from '../../models/moments-report/feed-card';

const FeedCard = ({ name, count, icon }: IFeedCardDetails) => {
    return (
        <div className="micro-card-06">
            <p className="c-item-01">{name}</p>
            <div className="c-item-02">
                <p className="c-unit-01">{count}</p>
            </div>
            {/* <img className="c-item-03" src={icon} alt={icon} /> */}
        </div>
    );
};

export default FeedCard;
